<div class="card-lead" id="lead-card-{{id}}" (click)="getRouter()">
  <div class="header-card">
    <div class="icon">
      <img src="../../../assets/svgs/{{dashboard.icon}}.svg" alt="Porcentagem">
    </div>
    <p class="text">{{ dashboard.title }}</p>
  </div>
  <div class="description">
    <p class="text">{{ dashboard.values.total }} {{ dashboard.type === 'ACTIVE_CAMPAIGNS' ? 'campanhas' : null }}</p>
  </div>
</div>